<govuk-table [columns]="tableColumns()" [data]="sortedFacilityItems()" (sort)="sorting.set($event)">
  <ng-template let-column="column" let-row="row">
    @switch (column.field) {
      @case ('name') {
        <a class="govuk-link" [routerLink]="['../', 'facility', row.facilityId]"> {{ row[column.field] }}</a>
      }

      @case ('status') {
        {{ row[column.field] | status }}
      }

      @case ('links') {
        @if (isEditable()) {
          <div class="govuk-!-text-align-right">
            <a class="govuk-link" [routerLink]="['../', row.facilityId, 'edit']">Edit</a>

            @switch (row[statusColumn]) {
              @case ('NEW') {
                <a class="govuk-!-padding-left-3 govuk-link" [routerLink]="['../', row.facilityId, 'delete']">
                  Delete
                </a>
              }

              @case ('LIVE') {
                <a class="govuk-!-padding-left-3 govuk-link" [routerLink]="['../', row.facilityId, 'exclude']">
                  Exclude
                </a>
              }

              @case ('EXCLUDED') {
                <a class="govuk-!-padding-left-3 govuk-link" [routerLink]="['../', row.facilityId, 'undo']"> Undo </a>
              }
            }
          </div>
        }
      }

      @case ('decisionStatus') {
        @if (row[column.field] !== 'UNCHANGED') {
          <govuk-tag [color]="row[column.field] | statusColor">
            {{ row[column.field] | status }}
          </govuk-tag>
        } @else {
          {{ row[column.field] | status }}
        }
      }

      @case ('chargeStartDate') {
        {{ row[column.field] | date }}
      }

      @default {
        {{ row[column.field] }}
      }
    }
  </ng-template>
</govuk-table>
